/**
 * @generated SignedSource<<01470caf037adcba45d6753874d14046>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventNewContent_user$data = {
  readonly guildsForNewEvents: {
    readonly nodes: ReadonlyArray<{
      readonly defaultTimeZone: string | null | undefined;
      readonly rowId: string;
      readonly slugId: string;
    } | null | undefined>;
  };
  readonly id: string;
  readonly rowId: string;
  readonly " $fragmentSpreads": FragmentRefs<"EventOwnerPicker_user">;
  readonly " $fragmentType": "EventNewContent_user";
};
export type EventNewContent_user$key = {
  readonly " $data"?: EventNewContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventNewContent_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventNewContent_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventOwnerPicker_user"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 500
        }
      ],
      "concreteType": "GuildsConnection",
      "kind": "LinkedField",
      "name": "guildsForNewEvents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Guild",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slugId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultTimeZone",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "guildsForNewEvents(first:500)"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "249a58d29f11ed9584bdcb05be07a798";

export default node;
